// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper--zFS","spinner":"Loader_spinner--mt8","rotateClockwise":"Loader_rotateClockwise--sLC","rotateCounterClockwise":"Loader_rotateCounterClockwise--SiK"};